import Tags from "./Tags";
import Button from "./Button";
import { Link } from "react-router-dom";
import { CarWithDealer } from "../data/models";

import { Carousel as ReactCarousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";

export interface CarouselCardProps {
  data: CarWithDealer;
}

export function CarouselCard(props: CarouselCardProps) {
  const { data } = props;
  const tags = [
    data.type_hr,
    data.color_f,
    data.color_design,
    data.trim_design,
  ];

  return (
    <div className="relative flex flex-col h-full gap-4 overflow-hidden border rounded-md border-light">
      <ReactCarousel
        showThumbs={true}
        autoPlay
        infiniteLoop
        className="carousel-card"
      >
        {data.link && <img src={data.link} alt="Foto 1" />}
        {data.foto1 && <img src={data.foto1} alt="Foto 2" />}
        {data.foto2 && <img src={data.foto2} alt="Foto 3" />}
        {data.foto3 && <img src={data.foto3} alt="Foto 4" />}
        {data.foto4 && <img src={data.foto4} alt="Foto 5" />}
      </ReactCarousel>

      <div className="flex items-center justify-between gap-6 px-4">
        <Link to={`/car/${data.id}`}>
          <h3 className="text-base font-bold uppercase text-gray-extra-dark">
            {data.brand}&nbsp;{data.family}
          </h3>
        </Link>
        {data.mask_price !== "0" && data.mask_price?.length > 0 ? (
          <div className="flex gap-2">
            {data.mask_price_akcija?.length > 0 ? (
              <>
                <div className="flex items-end font-medium pb-[0.5px] text-[13px] text-gray-extra-dark text-opacity-80 whitespace-nowrap line-through decoration-primary-red decoration-[1.5px]">
                  {Number(data.mask_price).toLocaleString("de-DE", {
                    maximumFractionDigits: 0,
                  })}{" "}
                  €
                </div>
                <div className="text-base font-medium text-primary-blue whitespace-nowrap">
                  {Number(data.mask_price_akcija).toLocaleString("de-DE", {
                    maximumFractionDigits: 0,
                  })}{" "}
                  €
                </div>
              </>
            ) : (
              <div className="text-base font-medium text-gray-extra-dark whitespace-nowrap">
                {Number(data.mask_price).toLocaleString("de-DE", {
                  maximumFractionDigits: 0,
                })}{" "}
                €
              </div>
            )}
          </div>
        ) : (
          <p className="text-base font-bold text-center text-primary-blue">
            Cijena na upit
          </p>
        )}
        {/* <h4 className="text-sm text-right opacity-25 text-primary-black">
          {data.dealer.name}
        </h4> */}
      </div>

      {/* <div className="flex justify-between">
        <Tags tags={tags} lengthShown={2}></Tags>
        <div className="text-lg font-medium text-right text-primary-black whitespace-nowrap">
          {Number(data.mask_price).toLocaleString("de-DE", {
            maximumFractionDigits: 0,
          })}{" "}
          €
        </div>
      </div> */}

      <div className="flex flex-col gap-4 px-4">
        <p className="text-[13px] text-gray-extra-dark opacity-80">
          {data.model_designation}
        </p>

        <Tags tags={tags} lengthShown={10} className="flex-1"></Tags>
        {/* <Tags tags={tags} lengthShown={2}></Tags> */}

        <div className="flex flex-col flex-1 gap-1">
          {data.co2_hr && data.co2_hr !== "-" && (
            <p className="text-xs text-gray-dark">
              CO2 emisije kombinirane: {data.co2_hr}
            </p>
          )}
          {data.mask_potrosnja && (
            <p className="text-xs text-gray-dark">
              Potrošnja goriva kombinirano: {data.mask_potrosnja}
            </p>
          )}
        </div>
      </div>

      <div className="flex items-center flex-1 gap-2 px-4 pb-0 mt-2">
        <div className="w-[50px] h-[50px] bg-gray-light rounded-md flex justify-center items-center">
          <svg
            width="20"
            height="20"
            viewBox="0 0 800 800"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0_1140_23590)">
              <path
                d="M400 800L380 786.667C366.667 776.667 66.6667 573.333 66.6667 333.333C66.6667 150 216.667 0 400 0C583.333 0 733.333 150 733.333 333.333C733.333 573.333 433.333 776.667 420 786.667L400 800ZM400 66.6667C253.333 66.6667 133.333 186.667 133.333 333.333C133.333 506.667 336.667 670 400 720C463.333 670 666.667 506.667 666.667 333.333C666.667 186.667 546.667 66.6667 400 66.6667ZM400 466.667C326.667 466.667 266.667 406.667 266.667 333.333C266.667 260 326.667 200 400 200C473.333 200 533.333 260 533.333 333.333C533.333 406.667 473.333 466.667 400 466.667ZM400 266.667C363.333 266.667 333.333 296.667 333.333 333.333C333.333 370 363.333 400 400 400C436.667 400 466.667 370 466.667 333.333C466.667 296.667 436.667 266.667 400 266.667Z"
                fill="black"
              />
            </g>
            <defs>
              <clipPath id="clip0_1140_23590">
                <rect width="800" height="800" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </div>
        <div className="flex flex-col gap-1">
          <p className="text-xs text-gray-dark">Odmah dostupno kod:</p>

          <Link
            to="#"
            onClick={(e) => {
              e.preventDefault();
              window.open(data.dealer.url, "_blank", "noopener,noreferrer");
            }}
            className="size-fit custom-link"
          >
            {data.dealer !== null && (
              <p className="text-xs uppercase text-gray-extra-dark">
                {data.dealer.name}
              </p>
            )}
          </Link>
        </div>
      </div>

      <Link to={`/car/${data.id}`} className="m-4 mt-0">
        <Button
          text={"Saznajte više"}
          variant={"primary"}
          size={"base"}
          width="w-full"
          className="text-[15px]"
        ></Button>
      </Link>
    </div>
  );
}

export default CarouselCard;
